import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Autocomplete } from "@mui/material";
import { defaultOf } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { ServiceType__get_Id, ServiceType__ToString_12C6553D, ServiceType_get_All } from "../../Shared/Shared.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";

export function Activities_TypeSelection_351560E3(activities_TypeSelection_351560E3InputProps) {
    let options;
    const error = activities_TypeSelection_351560E3InputProps.error;
    const onChange = activities_TypeSelection_351560E3InputProps.onChange;
    const typeOpt = activities_TypeSelection_351560E3InputProps.typeOpt;
    const ctx = reactApi.useContext(ctx_1);
    const error_1 = defaultArg(error, false);
    return MuiHelpers_createElement(Autocomplete, [["freeSolo", false], ["value", defaultArg(typeOpt, defaultOf())], (options = ServiceType_get_All(), ["options", Array.from(options)]), ["getOptionLabel", (item) => {
        if (item.tag === 17) {
            return ctx.Locale.t("Other");
        }
        else {
            return ServiceType__ToString_12C6553D(item, ctx.Language);
        }
    }], ["isOptionEqualToValue", ((o, v) => (ServiceType__get_Id(o) === ServiceType__get_Id(v)))], ["onChange", (_arg, v_1, _arg_1) => {
        onChange(v_1);
    }], ["renderInput", (props) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["label", ctx.Locale.t("Services.ServiceType")]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["error", error_1]), delay(() => (error_1 ? singleton(["helperText", ctx.Locale.t("Services.Errors.MissingType")]) : empty()))))))))))))]]);
}

